export enum RadioButtonSize {
  Small = "small",
  Regular = "regular"
}
